import { get } from "../Config";

//GET
export function SearchMonthlySlotList({ params }) {
  return get({ url: `/api/sb/v1/searchSlotMonthly`,params});
}
